import { Image, Pressable } from "react-native";
import { useRouter } from "expo-router";
import { memo } from "react";
import { usePostHog } from "posthog-js/react";

const Logo = () => {
  const router = useRouter();
  const posthog = usePostHog();

  const lomanlogo = require("../../../assets/lomanlogo.png");
  return (
    <Pressable
      className="flex-shrink-0"
      onPress={() => {
        posthog.capture("home_pressed");
        router.push({
          pathname: "/",
        });
      }}
    >
      <Image
        source={lomanlogo}
        style={{
          width: 130,
          height: 50,
          alignSelf: "flex-end",
        }}
        resizeMode="contain"
      />
    </Pressable>
  );
};

export default memo(Logo);
